import { useOutletContext } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import ThemeConstants from '../../../../../config/theme/theme_constants';
import { useUpdateCareerStatus } from '../../../../../core/components/user/domain/hooks/use_get_user_profile';
import { CareerStatusEnum } from '../../../../../core/enum/career_status_enum';
import LockIcon from '../../../../../assets/images/lock_icon.svg?react';
import { UserInterface } from '../../../../../core/components/user/domain/interfaces/user_interface';
import { useCallback } from 'react';
import { useTranslation } from '../../../../../i18n/useTranslation';

const UnlockCard: React.FC = () => {
  const { t } = useTranslation();
  const theme = ThemeConstants();
  const { getUserProfile } = useOutletContext<UserInterface>();
  const queryClient = useQueryClient();
  const { mutate: updateCareerStatus, isPending } = useUpdateCareerStatus();

  const handleStartJourney = useCallback(() => {
    updateCareerStatus(
      { status: CareerStatusEnum.InactiveTheme },
      {
        onSuccess: () => {
          queryClient.setQueryData(
            ['userProfile'],
            (old: UserInterface | undefined) =>
              old ? { ...old, careerStatus: CareerStatusEnum.InactiveTheme } : old,
          );
          if (getUserProfile) getUserProfile();
        },
        onError: () => {
          toast.error(t('course.lock.start_error'));
        },
      },
    );
  }, [getUserProfile, updateCareerStatus, queryClient, t]);

  return (
    <div className="flex flex-col w-full fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] justify-center items-center gap-14.5 z-50">
      <button
        className="text-white px-8.25 py-2.25 cursor-pointer rounded-[15px] font-bold disabled:opacity-60 disabled:cursor-not-allowed"
        style={{ backgroundColor: theme.UvibesPink }}
        onClick={handleStartJourney}
        disabled={isPending}
      >
        {t('course.lock.start')}
      </button>
      <LockIcon className="w-24 h-24" color="white" />
    </div>
  );
};

export default UnlockCard;
